<template>
  <div class="wrap vertical-spacing page-container">
    <div class="container-fluid">
      <div class="row">
        <div class="col-xs">
          <Loader :loading="isLoading" :text="$t('Loading Page...')">
            <SfHeading
              v-if="title"
              :title="title"
              :level="2"
              class="heading sf-heading--no-underline m-b-25"
            />
            <div class="page-content" v-html="body" />
          </Loader>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios';
import { SfHeading } from '@storefront-ui/vue';
import config from '@/config';
import { Loader } from '@/modules/core';

const { endpoints } = config.page;

export default {
  name: 'Page',
  components: {
    Loader,
    SfHeading,
  },
  data() {
    return {
      body: '',
      title: '',
      isLoading: true,
    };
  },
  created() {
    const { url } = this.$route.params;

    axios({ url: endpoints.page(url) })
      .then(({ data }) => {
        this.body = data.Body;
        this.title = data.Title;
      }).catch(() => {
        this.$router.push({ path: '/404' });
      })
      .finally(() => {
        this.isLoading = false;
      });
  },
};
</script>
